import {
  handleAuth as commonHandleAuth,
  reloadWindowOnStorageChange as commonReloadWindowOnStorageChange,
  AuthState,
  getOrderErrorMessage,
  getOrderErrorLink
} from '@amzn/d2c-application-website-common';
import {Dispatch} from '@reduxjs/toolkit';
import { store } from 'src/store/store';
import { setAuthInProgress, setAuthState } from 'src/store/authSlice';
import { awsRum } from 'src/rum';
import {LOCAL_HOSTNAME} from "src/constants/appConstants";

export { getOrderErrorMessage, getOrderErrorLink };

export const handleAuth = (clientId: string, redirectUrl: string) => {
  commonHandleAuth(clientId, redirectUrl, store, setAuthInProgress, (context, error, status) => {
    awsRum?.recordEvent('LWAError', { context, error: String(error), status });
  });
};

export const reloadWindowOnStorageChange = (dispatch: Dispatch, prevValue: AuthState) => {
  return commonReloadWindowOnStorageChange(dispatch, prevValue, setAuthState);
};

export const isLocalHost = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '0.0.0.0' || hostname === '127.0.0.1' || hostname === LOCAL_HOSTNAME;
};

export const isPreviewHost = (): boolean => {
  return isLocalHost() || window.location.hostname.includes('preview');
};
